// recon-period-messages translations (Norwegian source catalog).
window.PlummeI18n.register('no', {
  'rcd.areaStatus.notStarted': 'Ikke påbegynt',
  'rcd.areaStatus.inProgress': 'Under arbeid',
  'rcd.areaStatus.waitingPeriodEnd': 'Venter på periodeslutt',
  'rcd.areaStatus.deviation': 'Avvik',
  'rcd.areaStatus.approved': 'Godkjent',
  'rcd.areaStatus.notRelevant': 'Ikke relevant',
  'rcd.result.passed': 'Bestått',
  'rcd.result.waiting': 'Venter',
  'rcd.result.deviation': 'Avvik',
  'rcd.result.blocked': 'Blokkert',
  'rcd.result.notAssessed': 'Ikke vurdert',
  'rcd.type.auto': 'Automatisk kontroll',
  'rcd.type.professional': 'Faglig vurdering',
  'rcd.type.controller': 'Kontrollørkontroll',
  'rcd.area.noExternalBalance': 'Ingen ekstern saldo å sammenlikne mot',
  'rcd.area.noBalanceChecklist': 'Ingen saldo — området er kontrollpunkter',
  'rcd.area.unexplained': '{amount} uforklart',
  'rcd.area.matchesLedger': 'Stemmer mot hovedbok',
  'rcd.area.checkpoints': 'Kontrollpunkter for perioden',
  'rcd.area.accountOne': '{count} konto',
  'rcd.area.accountMany': '{count} kontoer',
  'rcd.area.noAccounts': 'Ingen kontoer',
  'rcd.area.docsMissing': '{count} mangler',
  'rcd.area.docsComplete': 'Komplett',
  'rcd.comp.inbox': 'Uposterte dokumenter i innboksen',
  'rcd.comp.received': 'Dokumenter mottatt, men ikke bokført',
  'rcd.comp.receivedNote': 'Inngår i de uposterte dokumentene over — telles ikke to ganger.',
  'rcd.comp.bankNoDoc': 'Banktransaksjoner uten bilag',
  'rcd.comp.docNoBank': 'Bilag uten koblet betaling',
  'rcd.comp.duplicates': 'Duplikatmistenkte bilag',
  'rcd.comp.outsidePeriod': 'Posteringer med dato utenfor perioden',
  'rcd.comp.outsidePeriodNote': 'Plumme fører ikke mottaksdato ved siden av bilagsdatoen, og kan derfor ikke skille en riktig etterpostering fra en feildatert.',
  'rcd.comp.lateManual': 'Manuelle posteringer nær periodeslutt',
  'rcd.comp.lateManualNote': 'Manuelle bilag datert de siste {days} dagene i perioden. Et forslag om hva som bør ses på — ikke en påstand om feil.',
  'rcd.comp.cutoff': 'Mulige feilperiodiseringer',
  'rcd.comp.cutoffNote': 'Krever leveranse- eller mottaksdato ved siden av bilagsdatoen. Plumme har ikke det sporet ennå.',
  'rcd.group.revenue': 'Omsetning',
  'rcd.group.cogs': 'Varekostnad',
  'rcd.group.payroll': 'Lønnskostnad',
  'rcd.group.otherOpex': 'Andre driftskostnader',
  'rcd.basis.previousMonth': 'Forrige måned',
  'rcd.basis.lastYear': 'Samme periode i fjor',
  'rcd.basis.budget': 'Budsjett',
  'rcd.basis.forecast': 'Prognose',
  'rcd.priority.critical': 'Kritisk',
  'rcd.priority.high': 'Høy',
  'rcd.priority.normal': 'Normal',
  'rcd.taskStatus.open': 'Åpen',
  'rcd.taskStatus.waitingClient': 'Venter på kunde',
  'rcd.taskStatus.needsReview': 'Må vurderes',
  'rcd.taskStatus.resolved': 'Løst',
  'rcd.task.clientRequest': 'Kundeforespørsel',
  'rcd.task.docRequest': 'Forespørsel om dokumentasjon',
  'rcd.task.inbox': 'Innboks',
  'rcd.task.inboxRef': 'INNBOKS',
  'rcd.task.processInbox': 'Behandle {count} uposterte dokumenter',
  'rcd.reportStatus.notStarted': 'Ikke startet',
  'rcd.reportStatus.dataIncomplete': 'Datagrunnlag ufullstendig',
  'rcd.reportStatus.readyToPrepare': 'Klar til utarbeidelse',
  'rcd.reportStatus.readyToSubmit': 'Klar til innsending',
  'rcd.reportStatus.submitted': 'Innsendt',
  'rcd.reportStatus.waitingPeriodEnd': 'Venter på periodeslutt',
  'rcd.report.period': 'Perioderapport til kunde',
  'rcd.report.result': 'Resultatrapport',
  'rcd.report.balance': 'Balanserapport',
  'rcd.report.ledger': 'Hovedbok',
  'rcd.report.aged': 'Aldersfordelt kunde- og leverandørliste',
  'rcd.report.dataComplete': 'Komplett',
  'rcd.report.dataIncomplete': 'Ufullstendig',
  'rcd.report.dueOwn': 'Byråets egen periodefrist',
  'rcd.report.dueNone': 'Ingen periodefrist er satt på perioden',
  'rcd.report.vat': 'MVA-melding',
  'rcd.report.vatTerm': 'Termin {term} {year}',
  'rcd.report.dueVatModel': 'Beregnet av MVA-terminmodellen',
  'rcd.report.aMelding': 'A-melding',
  'rcd.report.withholding': 'Forskuddstrekk og arbeidsgiveravgift',
  'rcd.report.dueNotRegistered': 'Frist ikke registrert i Plumme — følges opp i lønnsflaten',
  'rcd.master.bank': 'Alle bankkontoer er avstemt',
  'rcd.master.subledger': 'Kunde- og leverandørreskontro er avstemt',
  'rcd.master.vat': 'MVA er kontrollert',
  'rcd.master.payroll': 'Lønn og offentlige avgifter er kontrollert',
  'rcd.master.docs': 'Dokumentasjonen er komplett',
  'rcd.master.docsSource': '{area}: {count} konto(er) uten dokumentasjon',
  'rcd.master.docsAllOk': 'Alle kontoer som krever et eksternt grunnlag har dokumentasjon eller et notat',
  'rcd.master.docsText': 'Avvik – {count} dokumentkrav mangler',
  'rcd.master.reporting': 'Perioden er klar til rapportering',
  'rcd.cross.unexplainedDiff': 'Uforklart differanse',
  'rcd.cross.matches': 'Stemmer',
  'rcd.cross.ledgerRule': 'Hovedboken balanserer med like summer i debet og kredit.',
  'rcd.cross.srcLedger': 'Hovedbok',
  'rcd.cross.ledgerOff': 'Debet og kredit går ikke opp',
  'rcd.cross.bankRule': 'Banksaldoer stemmer med bankavstemmingene.',
  'rcd.cross.srcBank': 'Bank, hovedbok',
  'rcd.cross.subledgerRule': 'Kunde- og leverandørreskontro stemmer med hovedboken.',
  'rcd.cross.srcSubledger': 'Kundefordringer, leverandørgjeld, hovedbok',
  'rcd.cross.vatRule': 'MVA-grunnlaget stemmer med relevante hovedbokskontoer.',
  'rcd.cross.srcVat': 'MVA-avstemming, hovedbok',
  'rcd.cross.payrollRule': 'Lønnsgrunnlaget stemmer med lønnskjøring og hovedbok.',
  'rcd.cross.srcPayroll': 'Lønnssystem, hovedbok, A-melding',
  'rcd.cross.taxRule': 'Skattetrekk og offentlige avgifter stemmer med lønns- og avgiftsgrunnlaget.',
  'rcd.cross.srcTax': 'Lønnssystem, skattekonto',
  'rcd.cross.waitingPeriodEnd': 'Venter på periodeslutt',
  'rcd.cross.signRule': 'Eiendelskontoer med negativ saldo er undersøkt.',
  'rcd.cross.srcTrialBalance': 'Saldobalanse',
  'rcd.cross.negativeAccounts': '{count} konto(er) med negativ saldo',
  'rcd.cross.noneFound': 'Ingen funnet',
  'rcd.cross.unclearedRule': 'Midlertidige og uavklarte kontoer er gjennomgått.',
  'rcd.cross.srcOther': 'Øvrig balanse',
  'rcd.cross.openItems': '{count} åpne poster',
  'rcd.cross.noOpenItems': 'Ingen åpne poster',
  'rcd.cross.itemsRule': 'Alle vesentlige avstemmingsposter er behandlet eller dokumentert for oppfølging.',
  'rcd.cross.srcAllAreas': 'Alle områder',
  'rcd.cross.itemsStillOpen': '{count} poster fortsatt åpne',
  'rcd.cross.allItemsDone': 'Alle poster er behandlet',
  'rcd.cross.itemsCount': '{count} poster',
  'rcd.cross.changedRule': 'Ingen godkjent avstemming er endret uten ny kontroll.',
  'rcd.cross.srcActivityLog': 'Aktivitetslogg',
  'rcd.cross.changedAfterApproval': '{areas} er endret etter godkjenning',
  'rcd.cross.areasCount': '{count} områder',
  'rcd.auto.noAccountsInArea': 'Ingen kontoer i området',
  'rcd.auto.a1': 'Alle relevante avstemmingsområder er identifisert.',
  'rcd.auto.a1Source': '{count} områder identifisert ut fra klientoppsettet',
  'rcd.auto.a2': 'Alle bankkontoer er avstemt.',
  'rcd.auto.a3': 'Kunde- og leverandørreskontro er avstemt.',
  'rcd.auto.a4': 'MVA er kontrollert når dette er relevant for perioden.',
  'rcd.auto.a5': 'Lønn og offentlige avgifter er kontrollert når dette er relevant.',
  'rcd.auto.a6': 'Alle vesentlige balanseområder er behandlet.',
  'rcd.auto.b2': 'Banktransaksjoner uten dokumentasjon er fulgt opp.',
  'rcd.auto.b2Source': '{count} banktransaksjoner uten bilag',
  'rcd.auto.b2NoBank': 'Ingen bankavstemming i perioden',
  'rcd.auto.c1': 'Resultatutviklingen er sammenlignet med relevant sammenligningsgrunnlag.',
  'rcd.auto.c1Source': '{count} nøkkeltall sammenlignet mot {basis}',
  'rcd.auto.c1NoLines': 'Ingen resultatlinjer i perioden',
  'rcd.auto.d1': 'Rapporteringsgrunnlaget bygger på et uendret avstemmingsgrunnlag.',
  'rcd.auto.d1Unchanged': 'Ingen godkjent avstemming er endret etterpå',
  'rcd.auto.d2': 'Alle rapporter og plikter for perioden er identifisert.',
  'rcd.auto.d2Source': '{count} rapporter/plikter identifisert',
  'rcd.auto.d3': 'Rapporter og spesifikasjoner har komplett datagrunnlag.',
  'rcd.auto.d3Source': '{count} rapporter har ufullstendig datagrunnlag',
  'rcd.auto.d3AllComplete': 'Alle rapporter har komplett datagrunnlag',
  'rcd.auto.d5': 'Perioden er klar til kontroll.',
  'rcd.auto.d5Blocked': 'Beregnet — se blokkeringene i konklusjonen',
  'rcd.auto.d5None': 'Ingen blokkeringer',
  'rcd.auto.d4': 'Analytiske avvik er forklart.',
  'rcd.auto.d4Source': '{count} analytiske avvik uten forklaring',
  'rcd.auto.d4AllExplained': 'Alle sammenlikninger er forklart eller innenfor forventning',
  'rcd.group.scope': 'A. Omfang og avstemminger',
  'rcd.group.completeness': 'B. Fullstendighet og periodisering',
  'rcd.group.analytical': 'C. Analytisk kontroll',
  'rcd.group.reporting': 'D. Rapportering',
  'rcd.group.professional': 'Faglige vurderinger',
  'rcd.blocker.deviation': '{count} konto(er) står som avvik',
  'rcd.blocker.missingDocs': '{count} konto(er) mangler dokumentasjon',
  'rcd.blocker.openItems': '{count} åpne avstemmingsposter',
  'rcd.blocker.waitingTermEnd': 'Venter på periodeslutt — terminen er over {date}',
  'rcd.blocker.basisMoved': 'Grunnlaget har flyttet seg etter godkjenning',
  'rcd.blocker.inboxGroup': 'Innboks',
  'rcd.blocker.inboxItems': '{count} dokumenter er ikke behandlet',
  'rcd.blocker.analyticalGroup': 'Analytisk kontroll',
  'rcd.blocker.explanationsMissing': '{count} forklaringer mangler ({areas})',
  'rcd.blocker.periodGroup': 'Perioden',
  'rcd.blocker.periodNotEnded': 'Perioden er ikke avsluttet ennå',
});
